function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}
module.exports = _functionName;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_functionName.js
// module id = 1456
// module chunks = 14